export const UNREAD_MESSAGES_CHANGED_EVENT = 'madpaws:unread-messages-changed';

/**
 * Tells the platform header that the unread message count may have changed
 * (a message arrived, or a conversation was read) so it can refetch the badge.
 */
export const notifyUnreadMessagesChanged = (): void => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(UNREAD_MESSAGES_CHANGED_EVENT));
  }
};
